module.exports = "/assets/landing-rc/cooperation/pattern.png?IApjkun";